var map = {
	"./Alipay.svg": "3v6S",
	"./CheckworkBus.svg": "hogh",
	"./CheckworkN.svg": "rl+b",
	"./CheckworkO.svg": "GU/h",
	"./Class.svg": "qKG1",
	"./ClassN.svg": "e9RX",
	"./CommentN.svg": "akkd",
	"./CommentO.svg": "FOqG",
	"./DoctorN.svg": "LXSy",
	"./DoctorO.svg": "sZ4J",
	"./DriverN.svg": "4b6n",
	"./DriverO.svg": "a6sv",
	"./Kindergarten.svg": "E6Yt",
	"./KindergartenM.svg": "rrkI",
	"./KindergartenN.svg": "eZup",
	"./Place.svg": "Gu/w",
	"./PlaceN.svg": "RqeP",
	"./Principal.svg": "Etor",
	"./RecordN.svg": "+vpe",
	"./RecordO.svg": "DATn",
	"./Statistics.svg": "yqaF",
	"./StatisticsN.svg": "hBHI",
	"./Student-management.svg": "G2nZ",
	"./Student.svg": "41/G",
	"./StudentN.svg": "2IDP",
	"./StudentO.svg": "P+d0",
	"./StudentWorks.svg": "6V+R",
	"./TeachingplanN.svg": "932m",
	"./TeachingplanO.svg": "XRZ5",
	"./User-managementN.svg": "4iCu",
	"./User-managementO.svg": "JA0t",
	"./User-managementW.svg": "yIPm",
	"./Wexpay.svg": "t+oe",
	"./addFile.svg": "O5t+",
	"./addFiles.svg": "vSOy",
	"./anecdotal.svg": "aygR",
	"./archivesB.svg": "CIRY",
	"./archivesN.svg": "Dzyr",
	"./assessment.svg": "S8jH",
	"./babysitting.svg": "2bgl",
	"./boy.svg": "Niib",
	"./bus.svg": "hcqY",
	"./careGreetings.svg": "lqKm",
	"./careGreetingsB.svg": "cm8+",
	"./ceoN.svg": "AgD6",
	"./ceoO.svg": "5Llf",
	"./classCircle.svg": "XK5W",
	"./classCircleB.svg": "Faj2",
	"./clockimg.svg": "eBwZ",
	"./complementaryO.svg": "eT3Q",
	"./complementaryW.svg": "1ZvN",
	"./course.svg": "4t1d",
	"./curriculumN.svg": "YqNa",
	"./curriculumO.svg": "UJih",
	"./dailyW.svg": "nbrA",
	"./dashboard.svg": "BCGP",
	"./delFile.svg": "ZKcx",
	"./devicesW.svg": "5xFz",
	"./doctor.svg": "mJe2",
	"./drinkingwaterO.svg": "D0C2",
	"./drinkingwaterW.svg": "pXqv",
	"./emotionO.svg": "tQr/",
	"./emotionW.svg": "kyJU",
	"./entrustHome.svg": "Auw3",
	"./entrustHomeB.svg": "Elz0",
	"./entrustsB.svg": "zjpi",
	"./entrustsN.svg": "Oe5A",
	"./example.svg": "OOLB",
	"./expert.svg": "amMv",
	"./expertN.svg": "NFVC",
	"./expertO.svg": "14vg",
	"./eye-open.svg": "no6o",
	"./eye.svg": "4wdf",
	"./faceB.svg": "S743",
	"./faceO.svg": "/8Z/",
	"./faceW.svg": "fZMZ",
	"./fecesO.svg": "0fWt",
	"./fecesW.svg": "/hzo",
	"./file.svg": "fQ0v",
	"./files.svg": "KePA",
	"./form.svg": "sTIr",
	"./forms.svg": "gmfb",
	"./formsB.svg": "13m+",
	"./girl.svg": "j+Bt",
	"./group.svg": "hjGX",
	"./groupN.svg": "wypy",
	"./healthy.svg": "GfPS",
	"./healthyEpidemic.svg": "/gHL",
	"./healthyEpidemicB.svg": "i4yp",
	"./healthyW.svg": "NrQ0",
	"./homework.svg": "5u3i",
	"./homeworkO.svg": "JNGG",
	"./language.svg": "+Dip",
	"./leaveNotes.svg": "g1iG",
	"./leaveNotesB.svg": "nBrO",
	"./link.svg": "KgwQ",
	"./medication.svg": "QUJP",
	"./medicationW.svg": "qLRa",
	"./money.svg": "ig9B",
	"./nested.svg": "798r",
	"./no.svg": "3Wg0",
	"./notice.svg": "MqGM",
	"./noticeB.svg": "MMv1",
	"./objectives.svg": "sXvZ",
	"./objectivesB.svg": "qqHT",
	"./ok.svg": "zWFk",
	"./okk.svg": "eMcx",
	"./optionalFunction.svg": "+5Bi",
	"./optionalFunctionB.svg": "pzLu",
	"./password.svg": "QjmH",
	"./payrolls.svg": "jTAZ",
	"./payrollsB.svg": "Cv6m",
	"./pos.svg": "GMnF",
	"./predesignO.svg": "Sxy0",
	"./punch.svg": "4wcK",
	"./punchSetting.svg": "cQt3",
	"./reName.svg": "hzEo",
	"./refundCaculations.svg": "L61D",
	"./refundCaculationsB.svg": "Rhzu",
	"./schoolBus.svg": "6V5t",
	"./schoolBusB.svg": "nOiL",
	"./schoolBusO.svg": "Im1I",
	"./schoolBusW.svg": "Un3p",
	"./studentIc.svg": "oGcw",
	"./studentIcB.svg": "bvr9",
	"./table.svg": "oSYw",
	"./teachN.svg": "m2gx",
	"./teaching-r.svg": "P8t6",
	"./teaching.svg": "JCM8",
	"./teachingN.svg": "RKYm",
	"./teachingO.svg": "uJ/a",
	"./telphone.svg": "u3wy",
	"./templateB.svg": "lvqv",
	"./templateW.svg": "PYY7",
	"./trainingO.svg": "8Hay",
	"./trainingW.svg": "Am+W",
	"./tree.svg": "3eCm",
	"./true.svg": "sMv4",
	"./tuitionFee.svg": "9Ic0",
	"./tuitionFeeB.svg": "TAgX",
	"./tuitionW.svg": "m1/2",
	"./tuitionbillsB.svg": "FAVy",
	"./tuitionbillsW.svg": "zuXu",
	"./user.svg": "VdD3",
	"./userM.svg": "A/PT",
	"./userMa.svg": "pAoH",
	"./weighB.svg": "O0Mu",
	"./weighN.svg": "kDTQ",
	"./worksN.svg": "JtLe",
	"./worksO.svg": "StSg",
	"./ysCamera.svg": "P4wN",
	"./ysCameraB.svg": "wAzS",
	"./ysCameraO.svg": "h9qu"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 81